export enum E_ACCESS_PERMISSION {
    TYPE_PRIVATE = '0', //私有
    TYPE_PUBLIC = '1', //公开
    TYPE_ENTERPRISE_PUBLIC = '2', //企业内公开
    TYPE_ASSIGN = '3', //指定学员可见
    TYPE_ASSIGN_SE = '4' //销售平台内可见-销售平台内所有用户均可见
}
